var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", { attrs: { href: "#" } }, [
    _c("img", {
      staticClass: "uk-border-circle",
      staticStyle: { width: "36px", height: "36px" },
      attrs: {
        width: "36",
        height: "36",
        src:
          "https://cdnx.softsq.com/thumb/unsafe/36x36/" +
          encodeURIComponent(
            encodeURIComponent(
              _vm.profile.imageProfile ||
                "https://a.tourprox.com/logoprofile/112/logo.jpg"
            )
          ),
        "data-src": "holder.js/36x36",
        "data-holder-rendered": "true"
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd59b96a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd59b96a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReservationSmall.vue
// module id = null
// module chunks = 